// Replace the dummy Reports.tsx entirely
import { CompletedApplicationsReport } from "./CompletedApplicationsReport/CompletedApplicationsReport";

const Reports = () => <CompletedApplicationsReport />;
export default Reports;
